import * as Yup from 'yup';
/* -------------------------------------------------------------------------- */
/*                                  REQUIRED                                  */
/* -------------------------------------------------------------------------- */
export const nameRequired = Yup.string()
    // .min(2, 'Must be greater than 2 characters or more')
    .max(75, 'Must be 75 characters or less')
    .required('Name Required');

export const descriptionRequired = Yup.string()
    .max(500, 'Must be 500 characters or less')
    .required();

export const phoneNumberRequired = Yup.string()
    .transform((value) => value.replace(/[^\d+]/gu, ''))
    .required('Phone number is required')
    .matches(/^\+?[1-9]\d{9,14}$/u, 'Invalid phone number format')
    .min(10, 'Phone number must be at least 10 digits')
    .max(15, 'Phone number cannot exceed 15 digits');

export const checkBoxRequried = Yup.number()
    .oneOf([0, 1], 'Must be 0 or 1')
    .required('Required');

export const emailRequired = Yup.string()
    .email('Invalid email address')
    .required('Email is required');

export const passwordRequired = Yup.string()
    .matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!^#%*?&])[A-Za-z\d@$!%*#\\^?&]{8,16}$/u, 'Password must meet requirements')
    .required('Required');

export const checkBoxCheckedRequired = Yup.boolean()
    .oneOf([true], 'You must accept terms and conditions')
    .required('Required');

export const numberRequired = Yup.number()
    .moreThan(-1, 'More than 0')
    .required('Value Required');

export const DueDateRequired = Yup.number()
    .moreThan(1, 'days due more than 1')
    .required('Required');

export const stringRequired = Yup.string().required('value required');

/* -------------------------------------------------------------------------- */
/*                             OPTIONAL FIELDS                                */
/* -------------------------------------------------------------------------- */
export const nameOptional = Yup.string()
// .min(2)
    .max(75);
export const descriptionOptional = Yup.string()
// .min(2)
    .max(500);
export const checkboxOptional = Yup.number().oneOf([0, 1]);
export const phoneNumberOptional = Yup.string()
    .matches(/^\+?[1-9]\d{9,14}$/u, 'Invalid phone number format')
    .min(10, 'Phone number must be at least 10 digits')
    .max(15, 'Phone number cannot exceed 15 digits');
export const emailOptional = Yup.string().email('Invalid email address');
export const passwordOptional = Yup.string().matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,16}$/u, 'Password must meet complexity requirements');
export const checkboxCheckedOptional = Yup.boolean().oneOf([true], 'You must accept terms and conditions');
export const numberOptional = Yup.number();
export const dueDateOptional = Yup.number().moreThan(1, 'Due date must be more than 1 day');
export const stringOptional = Yup.string();

/* -------------------------------------------------------------------------- */
/*                               SCHEMA OBJECTS                               */
/* -------------------------------------------------------------------------- */


/**
* @danger: signupSchema
* @block_quote: Validation schema for signup form fields using Yup.
* @ol:
* first_name : {string} - The First name must be minimum 2 and maximum 75 characters and is required.
* last_name : {string} - The Last name must be minimum 2 and maximum 75 characters and is required.
* organisation_name : {string} - The organisation name must be minimum 2 and maximum 75 characters and is required.
* email : {string} - The email field must be a valid email address and is required.
* password : {string} - The password field must have a minimum length of 6 characters and is required.
* @code:
* const isValid = signupSchema.isValidSync({
    "first_name": "John",
    "last_name": "Doe",
    "email": "john.doe@example.com",
    "organization_name": "Acme Inc.",
    "password": "Password123!",
* });
* console.log(isValid); // true
* @separator:
*/
export const emailSchema = Yup.object({
    email: emailRequired
});

export const nameSchema = Yup.object({
    name: nameRequired
});